import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import { faAward } from '@fortawesome/free-solid-svg-icons';

const Tops = ({ top, item, ranking, registros }) =>
{
    return (
        <div className="col-xl-4 col-md-6 col-12">
            <div className="card border rounded-5 shadow-sm h-100 bg-white">
                <div className="card-header rounded-top-5 bg-white border-bottom py-3 d-flex align-items-center gap-2">
                    <FontAwesomeIcon className="text-primary" icon={faAward} />
                    <span className="fw-semibold">{top}</span>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive px-3 pb-3">
                        <table className="table table-sm table-hover table-borderless align-middle mb-0" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif', fontSize: '0.95rem' }}>
                            <thead>
                                <tr className="text-secondary small">
                                    <th scope="col" className="text-start py-2" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>{'N°'}</th>
                                    <th scope="col" className="text-start py-2" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>{item}</th>
                                    <th scope="col" className="text-end py-2" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>{'Núm. Archivos'}</th>
                                    <th scope="col" className="text-end py-2" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>{'%'}</th>

                                    { registros && (<th scope="col" className="text-end py-2" style={{ fontFamily: 'Inter, "Segoe UI", sans-serif' }}>{'Muestreos Biológicos'}</th>) }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ranking.map((ranking, index) =>
                                    (
                                        <tr key={index + 1} className="border-bottom">
                                            <th scope="row" className="small text-start py-2 text-body">{index + 1}</th>
                                            <td className="text-start py-2 text-body">{Object.values(ranking)[0]}</td>
                                            <td className="text-end font-monospace py-2 text-body">{Object.values(ranking)[1].toLocaleString('es-CL')}</td>
                                            <td className="text-end fw-bold py-2 text-primary">{Object.values(ranking)[2]}</td>

                                            { Object.values(ranking)[3] && (<td className="text-end font-monospace py-2 text-body">{Object.values(ranking)[3].toLocaleString('es-CL')}</td>) }
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Tops;
